import { dsClass } from '../../common/constants/dsClasses.js';
import { getSelectedAddonsContent } from '../SubscriptionAdditionalService/SubscriptionAdditionalService';
import { t } from '../../common/i18n/index.js';
import type { DeliveryOrderDetails } from '../../generated/api/models.js';

interface DeliveryOrderDetailsAddonsProps {
  details: DeliveryOrderDetails;
}

export const DeliveryOrderDetailsAddons = ({ details }: DeliveryOrderDetailsAddonsProps) => {
  return (
    <div className="of-delivery-order-details--section" key="of-delivery-order--section-addons">
      <h3 className={dsClass.H3}>{t.FK2F('Supplementary services ordered')}</h3>
      {getSelectedAddonsContent(details, false)}
    </div>
  );
};
